import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  faqs: [],
  loading: false,
  error: null,
};

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    fetchFaqs: (state) => {
      state.loading = true;
    },
    fetchFaqsSuccess: (state, action) => {
      state.loading = false;
      state.faqs = action.payload;
    },
    fetchFaqsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchFaqs, fetchFaqsSuccess, fetchFaqsFailure } =
  faqSlice.actions;

export default faqSlice.reducer;
